import BasicLayout from "./layouts/BasicLayout";
import "./App.css";

export default function App() {
  return <BasicLayout />;
}
